import React, { useState } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, message, Button, Input } from 'antd';
import { formValidation } from 'utils/form-utils';

export interface UserPasswrodResetModalProps extends PopupProps {
    username: string;
}

const UserResetPasswordModal = ({ isOpen, onClose, username }: UserPasswrodResetModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [isFormDone, setIsFormDone] = useState<boolean>(false);
   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();

   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };
        
    const onSubmit = (e) => {
        if (!validateRegistrant()) {
            message.error("비밀번호를 다시 확인 부탁 드립니다.", 1);
            return;
        }  
        
        onClose?.(true, e.newpassword);
      };

    const onChangeForm = () => {
        setIsFormDone(formValidation(form, ['username']));
    };      
    /* ======================================================
    * methods
    * ====================================================== */
    
    const validateRegistrant = () => {
        return form.getFieldValue('newpassword') === form.getFieldValue('newpasswordconfirm');
    };   

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={350} title={'비밀번호 변경'} closable>
            <Form
                form={form}
                name="resetPassword"
                layout="horizontal"  
                labelCol={{ span: 9 }}
                onFieldsChange={onChangeForm}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item name="username" label={'이름'}>
                    <label>{username}</label>
                </Form.Item>                
                <Form.Item name="newpassword" label="비밀번호" rules={[{ required: true, message: '' }]}>
                    <Input type="password" placeholder='비밀번호를 입력하세요' />
                </Form.Item>
                <Form.Item name="newpasswordconfirm" label="비밀번호 확인" rules={[{ required: true, message: '' }]}>
                    <Input type="password" placeholder='비밀번호를 재입력하세요' />
                </Form.Item>
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel}>
                    취소
                    </Button>
                    <Button htmlType="submit"  type="primary" disabled={!isFormDone}>
                    변경
                    </Button>
                </ButtonGroup>                
            </Form>
        </ModalWrapper>  
    )    
};

export default React.memo(UserResetPasswordModal);    